<template>
    <div id="school-modal" class="modal" v-bind:class="{'is-active': showModal}">
        <div class="modal-background"></div>
        <div class="modal-card">
            <header class="modal-card-head">
                <p class="modal-card-title">TITLE</p>
                <button class="delete" aria-label="close" @click="showModal = false"></button>
            </header>
            <section class="modal-card-body">
                <div class="columns is-multiline">
                    <div class="column is-6">
                        <div class="field">
                            <multiselect visible="auto" v-model="selectedSchools" label="name" name="schools" track-by="id" :options="schools" :multiple="true" placeholder="Choose schools"></multiselect>
                        </div>
                    </div>
                </div>
            </section>
            <footer class="modal-card-foot has-text-right">
                <button class="button is-info is-pulled-right" @click="showModal = false">Ok</button>
            </footer>
        </div>
    </div>
</template>
<script>

    import _ from 'lodash'

    export default {
        name: 'school-modal',
        components: {},
        props: {
            showModal: { required: true, default: false},
            selectedSchools: { required: true },
            schools: { default: []},
        },
        data() {
            return {
                loading: false,
                saving: false,
            }
        },
        created(){

        },
        mounted(){

        },
        methods: {},
        watch: {}

    }
</script>

<style lang="css" scoped>
    .modal-card-body {
        overflow: visible !important;
    }
    .modal-card{
        overflow: visible !important;
    }
</style>



// WEBPACK FOOTER //
// src/components/util/SchoolModal.vue